import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { FormattedMessage } from "react-intl";
import messages from "components/messagesDescription";
import withMatchMediaProps from "@hocs/with-match-media-props";
import StandardMoney from "../common/StandardMoney";

const ProductItem = ({ product, isNarrowScreen }) => {
  const {
    productId,
    productName,
    imageMain,
    percentDiscount,
    providerName,
    standardPrice,
    sellingPrice,
    currency,
    providerId,
  } = product;

  if (!product) {
    return null;
  }

  const ProductLink = props => <Link to={`/marketplace/product/${productId}`} {...props} />;
  const ProviderLink = props => <Link to={`/marketplace/provider/${providerId}`} {...props} />;
  const className = !isNarrowScreen ? "card-desktop" : "card-mobile";
  const discountDisplay = percentDiscount ? `- ${Math.round(percentDiscount)}% off` : "";
  const limit = isNarrowScreen ? 10 : 20;
  const providerDisplay =
    providerName.length > limit ? providerName.substring(0, limit) + "..." : providerName;
  return (
    <div className={className}>
      <div className="product-item">
        {discountDisplay && (
          <div className="discount-container ">
            <div className="discount">{discountDisplay}</div>
          </div>
        )}
        <ProductLink className="product-image">
          <img className="product-image-src" src={imageMain} alt=""  />
        </ProductLink>
        <div className="product-detail">
          <div className="product-header">
            <ProductLink>
              <div className="product-name">{productName}</div>
            </ProductLink>
            <FormattedMessage {...messages.marketplace.byDescription} />{" "}
            <ProviderLink>
              <strong>{providerDisplay}</strong>
            </ProviderLink>
          </div>
          <p style={{ marginTop: "15px" }}>
            {standardPrice > 0 && sellingPrice > 0 && standardPrice !== sellingPrice && (
              <s>
                <StandardMoney value={standardPrice} currency={currency || "SGD"} />
              </s>
            )}
            <br />
            {sellingPrice > 0 && (
              <strong>
                <StandardMoney value={sellingPrice} currency={currency || "SGD"} />
              </strong>
            )}
          </p>
        </div>
      </div>
    </div>
  );
};

ProductItem.propTypes = {
  product: PropTypes.object.isRequired,
  isNarrowScreen: PropTypes.bool,
};

export default withMatchMediaProps({
  isNarrowScreen: {
    maxWidth: 680,
  },
})(ProductItem);



// WEBPACK FOOTER //
// ./components/marketplace/ProductItem.jsx